import React, { useState, useEffect, useRef } from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogFooter 
} from './ui/dialog';
import { Button } from './ui/button';
import { Label } from './ui/Label';
import { Input } from './ui/input';
import { Textarea } from './ui/Textarea';
import { Checkbox } from './ui/checkbox';

import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { api } from '../services/api';
import { 
  CreditCard, 
  Calendar, 
  Wallet, 
  FileText, 
  User,
  Car,
  Bus,
  AlertCircle,
  CheckCircle,
  Users,
  Bell, 
  GraduationCap, 
  Trophy,
  Utensils, 
  Plus, 
  XCircle,
  Info,
  Loader2
} from 'lucide-react';

import { Toast } from './ui/Toast';
// ⚠️ `LongToast` EN PLUS DE `Toast`, ET CE N'EST PAS DÉCORATIF.
// Le toast court se ferme seul au bout de 3 secondes et ne connaît pas le
// type `warning`. Un refus de paiement — « le paiement n'a PAS été
// enregistré, ne remettez pas de reçu » — est long, grave, et doit rester
// à l'écran : `shouldUseLongToast` arbitre, comme partout ailleurs.
import { LongToast, shouldUseLongToast } from './ui/LongToast';
import ToastPortal from './ToastPortal';
import { useFeatures } from '../contexts/FeaturesContext';
import { useHabilitationCaisse } from '../hooks/useHabilitationCaisse';
import BandeauCaisseReservee from './caisse/BandeauCaisseReservee';

const normalizePaymentModeLabel = (value = '') => {
  return String(value || '')
    .replace(/Esp(?:è|è|Ã¨|ÃƒÂ¨|ÃƒÂƒÃ‚Â¨)ces/gi, 'Espèces')
    .replace(/Ch(?:è|è|Ã¨|ÃƒÂ¨|ÃƒÂƒÃ‚Â¨)que/gi, 'Chèque')
    .replace(/scolaris(?:é|é|Ã©|ÃƒÂ©)/gi, 'scolarisé');
};

const extractPaymentErrorMessage = (payload, fallback = "Erreur lors de l'enregistrement du paiement") => {
  if (!payload) return fallback;
  if (typeof payload === 'string') return payload;
  if (payload.message && payload.message !== 'Une erreur est survenue') return payload.message;
  if (typeof payload.error === 'string' && payload.error) return payload.error;
  if (payload.data?.message && payload.data.message !== 'Une erreur est survenue') return payload.data.message;
  if (typeof payload.data?.error === 'string' && payload.data.error) return payload.data.error;
  return payload.message || payload.error || fallback;
};
const AddPaymentModal = ({ isOpen, onClose, eleve, anneeActive, modesPaiement, formatMontant, onSave }) => {
  // « Soldé » atteste qu'un mois a été payé au site d'ou l'eleve vient : le
  // statut n'existe qu'apres un transfert inter-sites. Sans le module, aucun
  // transfert n'est possible, donc aucun eleve ne peut le porter — et l'afficher
  // ne prouverait rien. Il ne faut pas le renommer « Soldé » tout court : un
  // eleve a jour porte deja « Payé », et deux mots pour la meme chose seraient
  // une confusion de plus.
  const { estActive } = useFeatures();
  // Encaisser est réservé aux profils comptables : bandeau et bouton fermé
  const { habilite: habiliteCaisse } = useHabilitationCaisse();
  const interSitesOuvert = estActive('module.intersites');
  // Onglet actif
  const [activeTab, setActiveTab] = useState('scolarite');
  
  // État des catégories de frais
  const [categories, setCategories] = useState([
    { id: 'scolarite', nom: 'Scolarité', icon: <GraduationCap size={16} /> },
    { id: 'transport', nom: 'Transport', icon: <Bus size={16} /> },
    { id: 'cantine', nom: 'Cantine', icon: <Utensils size={16} /> }
    
  ]);

  

  
  // Données de paiement
  const isEleveInFamilleNombreuse = Boolean(
    eleve?.est_en_famille_nombreuse ||
    (
      eleve?.famille_nombreuse_id &&
      ['active', 'a_regulariser'].includes(String(eleve?.famille_statut || '').toLowerCase())
    )
  );
  const familleNom = eleve?.famille_nom || 'Famille nombreuse';
  const famillePaymentBlockedMessage = `Cet élève appartient à ${familleNom}. Les paiements doivent être gérés depuis le dossier de la famille nombreuse.`;

  const [paiementData, setPaiementData] = useState({
    eleve_id: eleve?.id || '',
    mode_paiement: '',
    numero_transaction: '',
    commentaire: '',
    date_paiement: new Date().toISOString().split('T')[0],
    // Tableau des paiements par catégorie et mois
    paiements: []
  });
  
  // État pour les mois cochés et les montants
  const [moisSelectionnes, setMoisSelectionnes] = useState({
    scolarite: [],
    transport: [],
    cantine: []
  
  });
  
  const [montantsSaisis, setMontantsSaisis] = useState({
    scolarite: {},
    transport: {},
    cantine: {}

  });
  
  // Données des mois et de l'historique de paiement
  const [moisScolaires, setMoisScolaires] = useState([]);
  const [historiquesPaiements, setHistoriquesPaiements] = useState({
    scolarite: {},
    transport: {},
    cantine: {},
   
  });
  
  // Deux attentes distinctes : lire l'historique a l'ouverture, et enregistrer
  // le paiement. Une seule variable faisait afficher « Enregistrement... » au
  // bouton pendant le simple chargement de la fenetre.
  const [chargementHistorique, setChargementHistorique] = useState(false);
  const [enregistrementEnCours, setEnregistrementEnCours] = useState(false);
  // Les champs restent fermes dans les deux cas : on ne coche pas un mois
  // dont on ne sait pas encore s'il est deja paye.
  const isLoading = chargementHistorique || enregistrementEnCours;

  const [modePaiementSearchTerm, setModePaiementSearchTerm] = useState('');
  const [isModePaiementDropdownOpen, setIsModePaiementDropdownOpen] = useState(false); 

  const [error, setError] = useState(null);
  // ⚠️ LE BLOC ROUGE EST LE PREMIER ENFANT D'UNE ZONE QUI DÉFILE, et le bouton
  // « Valider le paiement » est tout en bas : au moment du refus, l'utilisateur
  // ne voit pas le haut du modal. Sans ce renvoi, le message s'affiche hors de
  // son champ de vision et l'écran paraît n'avoir rien fait — sur le chemin
  // précis où l'argent a déjà été reçu.
  const blocErreurRef = useRef(null);
  // Décochée par défaut : un SMS se paie, et part vers un vrai numéro
  const [notifierParent, setNotifierParent] = useState(false);

  const [toastInfo, setToastInfo] = useState(null);

  const [paiementEffectue, setPaiementEffectue] = useState(false);


  const [fraisScolaires, setFraisScolaires] = useState({
    scolarite: null,
    transport: null,
    cantine: null
  
  });
  const createDefaultPaiementPonctuel = () => ({
    transport: {
      date_service: new Date().toISOString().split('T')[0],
      type_paiement: 'journee',
      sens_transport: 'aller',
      montant: '',
      observations: ''
    },
    cantine: {
      date_service: new Date().toISOString().split('T')[0],
      type_paiement: 'journalier',
      sens_transport: '',
      montant: '',
      observations: ''
    }
  });

  const [paiementPonctuel, setPaiementPonctuel] = useState(createDefaultPaiementPonctuel);
  const [isPaiementPonctuelLoading, setIsPaiementPonctuelLoading] = useState(false);



  const [moisNonScolarises, setMoisNonScolarises] = useState({
    scolarite: [],
    transport: [],
    cantine: []
  });
  

  // g?rer les warning 
  const [warningsMontants, setWarningsMontants] = useState({
    scolarite: {},
    transport: {},
    cantine: {}
  });



  //  État pour stocker les mois déjà payés et non scolarisés
  const [moisDejaPayes, setMoisDejaPayes] = useState({
    scolarite: [],
    transport: [],
    cantine: []
  });

  const [moisDejaNonScolarises, setMoisDejaNonScolarises] = useState({
    scolarite: [],
    transport: [],
    cantine: []
  });



  // Effet pour initialiser le formulaire avec l'élève
  useEffect(() => {
    if (eleve) {
      setPaiementData(prev => ({
        ...prev,
        eleve_id: eleve.id
      }));
    }
  }, [eleve]);
  

  // Effet pour charger les mois scolaires
  useEffect(() => {
    const fetchMoisScolaires = async () => {
      try {
        const response = await api.moisScolaires.getAll();
        if (response.success && Array.isArray(response.data)) {
          // Trier les mois par trimestre et par ordre
          const moisTries = response.data.sort((a, b) => {
            if (a.trimestre !== b.trimestre) {
              return a.trimestre - b.trimestre;
            }
            return a.ordre - b.ordre;
          });
          setMoisScolaires(moisTries);
        } else {
          console.error("Format de données inattendu pour les mois scolaires");
          setMoisScolaires([]);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des mois scolaires:", error);
        setMoisScolaires([]);
      }
    };
  
    fetchMoisScolaires();
  }, []);
  

  // Effet pour charger les frais scolaires bas?s sur la classe de l'élève
  useEffect(() => {
    if (!eleve || !eleve.classe_id) return;
  
    const fetchFraisScolaires = async () => {
      try {
        // R?cup?rer les d?tails de la classe pour obtenir tous les frais
        const classeResponse = await api.classes.getById(eleve.classe_id);
      
        if (classeResponse && classeResponse.id) {
          // ? CORRECTION : Utiliser les vraies données des frais de la classe
          setFraisScolaires({
            scolarite: parseFloat(classeResponse.frais_mensuel) || 0,
            transport: parseFloat(classeResponse.frais_transport) || 0,
            cantine: parseFloat(classeResponse.frais_cantine) || 0
          });

          console.log('Frais charg?s:', {
            scolarite: classeResponse.frais_mensuel,
            transport: classeResponse.frais_transport,
            cantine: classeResponse.frais_cantine
          });
        }
      } catch (error) {
        console.error("Erreur lors de la r?cup?ration des frais scolaires:", error);
        // Valeurs par défaut en cas d'erreur
        setFraisScolaires({
          scolarite: 50000,
          transport: 0,
          cantine: 0
        });
      }
    };
  
    fetchFraisScolaires();
  }, [eleve]);





  // Effet pour charger l'historique des paiements de l'élève
  useEffect(() => {
    if (!eleve || !anneeActive || moisScolaires.length === 0) return;
  
    const fetchPaiementsHistorique = async () => {
      setChargementHistorique(true);
      try {
        const [scolariteResponse, transportResponse, cantineResponse] = await Promise.all([
          api.finance.getPaiements(eleve.id, anneeActive.id, 'scolarite'),
          api.finance.getPaiements(eleve.id, anneeActive.id, 'transport'),
          api.finance.getPaiements(eleve.id, anneeActive.id, 'cantine')
        ]);
      
        const paiementsParCategorie = {
          scolarite: {},
          transport: {},
          cantine: {}
        };
        const moisPayesTemp = { scolarite: [], transport: [], cantine: [] };
        const moisNonScolarisesTemp = { scolarite: [], transport: [], cantine: [] };
        const allPaiements = [
          ...(Array.isArray(scolariteResponse) ? scolariteResponse : []),
          ...(Array.isArray(transportResponse) ? transportResponse : []),
          ...(Array.isArray(cantineResponse) ? cantineResponse : [])
        ];
      
        allPaiements.forEach(paiement => {
          const categorie = paiement.categorie || 'scolarite';
          if (!paiementsParCategorie[categorie]) {
            return;
          }
        
          paiementsParCategorie[categorie][paiement.mois_id] = {
            montant_attendu: paiement.montant_attendu || 0,
            montant_paye: paiement.montant_paye || 0,
            montant_restant: (paiement.montant_attendu || 0) - (paiement.montant_paye || 0),
            date_paiement: paiement.date_paiement,
            statut: paiement.statut,
            statut_frequentation: paiement.statut_frequentation,
            mode_paiement: paiement.mode_paiement
          };
        
          if ((paiement.statut === 'Payé' || paiement.statut === 'Payé' || paiement.statut === 'Soldé' || paiement.statut === 'Soldé') &&
            (paiement.montant_attendu - paiement.montant_paye) <= 0) {
            if (!moisPayesTemp[categorie].includes(paiement.mois_id)) {
              moisPayesTemp[categorie].push(paiement.mois_id);
            }
          }
        
          if (paiement.statut_frequentation === 'non_scolarise') {
            if (!moisNonScolarisesTemp[categorie].includes(paiement.mois_id)) {
              moisNonScolarisesTemp[categorie].push(paiement.mois_id);
            }
          }
        });
        
        setMoisDejaPayes(moisPayesTemp);
        setMoisDejaNonScolarises(moisNonScolarisesTemp);
      
        setHistoriquesPaiements({
          scolarite: paiementsParCategorie.scolarite,
          transport: paiementsParCategorie.transport,
          cantine: paiementsParCategorie.cantine
        });
  
        const initMontants = categories.reduce((acc, categorie) => {
          const catId = categorie.id;
          const montants = {};

          moisScolaires.forEach(mois => {
            const paiement = paiementsParCategorie[catId]?.[mois.id] || null;
            if (paiement && paiement.montant_restant > 0) {
              montants[mois.id] = paiement.montant_restant;
            }
          });

          return { ...acc, [catId]: montants };
        }, {});

        setMontantsSaisis(initMontants);
      } catch (error) {
        console.error("Erreur lors de la r?cup?ration de l'historique des paiements:", error);
      } finally {
        setChargementHistorique(false);
      }
    };

    fetchPaiementsHistorique();
  }, [eleve, anneeActive, moisScolaires]);




  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isModePaiementDropdownOpen && !event.target.closest('.relative')) {
        setIsModePaiementDropdownOpen(false);
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isModePaiementDropdownOpen]);



  // Gérer la sélection/d?sélection d'un mois
  const handleMoisToggle = (categorie, moisId) => {
    setMoisSelectionnes(prev => {
      const nouveauxMois = [...prev[categorie]];
      const index = nouveauxMois.indexOf(moisId);
      
      if (index === -1) {
        nouveauxMois.push(moisId);
      } else {
        nouveauxMois.splice(index, 1);
      }
      
      return { ...prev, [categorie]: nouveauxMois };
    });
  };
  


  // Gérer le changement de montant pour un mois
  const handleMontantChange = (categorie, moisId, value) => {
    //  Permettre de vider compl?tement le champ
    if (value === '' || value === null || value === undefined) {
      setMontantsSaisis(prev => ({
        ...prev,
        [categorie]: {
          ...prev[categorie],
          [moisId]: '' // Garder vide
        }
      }));
      // Pas de warning si le champ est vide
      setWarningsMontants(prev => ({
        ...prev,
        [categorie]: {
          ...prev[categorie],
          [moisId]: false
        }
      }));
      return;
    }

    // Convertir en nombre seulement si la valeur n'est pas vide
    const montant = parseFloat(value);

    // Si NaN, ignorer
    if (isNaN(montant)) {
      return;
    }

    // Validation : le montant ne peut pas être négatif
    if (montant < 0) {
      return;
    }

    // Gérer le warning si montant = 0
    if (montant === 0) {
      setWarningsMontants(prev => ({
        ...prev,
        [categorie]: {
          ...prev[categorie],
          [moisId]: true
        }
      }));
    } else {
      setWarningsMontants(prev => ({
        ...prev,
        [categorie]: {
          ...prev[categorie],
          [moisId]: false
        }
      }));
    }

    //  IMPORTANT : Stocker comme CHA?NE pour ?viter les probl?mes de saisie
    setMontantsSaisis(prev => ({
      ...prev,
      [categorie]: {
        ...prev[categorie],
        [moisId]: value // Garder la valeur originale (cha?ne)
      }
    }));
  };
 
  
  // Gérer le changement des champs texte
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaiementData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  // Calculer le total des montants sélectionnés
  const calculerTotalSelectionne = () => {
    let total = 0;
  
    categories.forEach(categorie => {
      const catId = categorie.id;
      moisSelectionnes[catId].forEach(moisId => {
        const montant = parseFloat(montantsSaisis[catId][moisId]) || 0; //  Parser ici
        total += montant;
      });
    });
  
    return total;
  };
  

  // Pr?parer les données pour la soumission
  const preparerDonneesSoumission = () => {
    const paiements = [];
  
    categories.forEach(categorie => {
      const catId = categorie.id;
    
      // Ajouter les paiements normaux
      moisSelectionnes[catId].forEach(moisId => {
        const montant = parseFloat(montantsSaisis[catId][moisId]) || 0; //  Parser ici
        if (montant > 0) {
          paiements.push({
            categorie_id: catId,
            mois_id: moisId,
            montant: montant,
            statut_frequentation: 'scolarise'
          });
        }
      });

      // Ajouter les mois non scolarisés
      moisNonScolarises[catId].forEach(moisId => {
        const moisNom = moisScolaires.find(m => m.id === moisId)?.nom || 'Mois';
        paiements.push({
          categorie_id: catId,
          mois_id: moisId,
          montant: 0,
          statut_frequentation: 'non_scolarise',
          justification_non_scolarise: `élève non scolarisé - ${moisNom}`
        });
      });
    });
    
    return {
      ...paiementData,
      paiements,
      annee_scolaire_id: anneeActive.id,
      notifier_parent: notifierParent
    };
  };
  


  // Soumettre le formulaire
  const handleSubmit = async () => {
    if (isEleveInFamilleNombreuse) {
      setError(famillePaymentBlockedMessage);
      setToastInfo({
        message: famillePaymentBlockedMessage,
        type: 'error'
      });
      return;
    }

    //  V?rifier s'il y a des paiements normaux ou des mois "non scolarisé"
    const aPaiementsNormaux = calculerTotalSelectionne() > 0;
    const aMoisNonScolarises = Object.values(moisNonScolarises).some(arr => arr.length > 0);
  
    // Validation : au moins un paiement OU un mois "non scolarisé"
    if (!aPaiementsNormaux && !aMoisNonScolarises) {
      setError("Veuillez sélectionner au moins un mois à payer ou marquer comme non scolarisé");
      return;
    }
  
    //  Si paiements normaux, mode de paiement obligatoire
    if (aPaiementsNormaux && !paiementData.mode_paiement) {
      setError("Veuillez sélectionner un mode de paiement");
      return;
    }
  
    //  Si uniquement "non scolarisé", mode de paiement doit être l'option spéciale OU null
    if (!aPaiementsNormaux && aMoisNonScolarises &&
      paiementData.mode_paiement !== 'Pas de mode de paiement car non scolarisé') {
      setError("Veuillez sélectionner 'Pas de mode de paiement car non scolarisé'");
      return;
    }
  
    // Traitement du formulaire (reste identique)
    setEnregistrementEnCours(true);
    setError(null);
  
    try {
      const donnees = preparerDonneesSoumission();
      const response = await api.finance.enregistrerPaiementMulti(donnees);
    
      if (response.success) {
        // Le résultat du SMS au parent (NotificationPaiementService) : un échec
        // ne remet pas le paiement en cause, mais doit se voir.
        const notification = response.data?.notification;
        setToastInfo({
          message: `Paiement enregistré avec succès : ${formatMontant(calculerTotalSelectionne())}`
            + (notification?.message ? `. ${notification.message}` : ''),
          type: notification && notification.statut !== 'envoye' ? 'info' : 'success'
        });

        setPaiementEffectue(true);
      
        // R?initialiser le formulaire
        setMoisSelectionnes({
          scolarite: [],
          transport: [],
          cantine: []
        });
        setMontantsSaisis({
          scolarite: {},
          transport: {},
          cantine: {}
        });
        setPaiementData(prev => ({
          ...prev,
          mode_paiement: '',
          numero_transaction: '',
          commentaire: ''
        }));
      
        if (onSave) {
          onSave(response.data);
        }
      } else {
        const errorMessage = extractPaymentErrorMessage(response);
        setError(errorMessage);

        // On amène le refus sous les yeux : voir le commentaire de `blocErreurRef`.
        requestAnimationFrame(() => {
          blocErreurRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });

        setToastInfo({
          message: errorMessage,
          type: 'error'
        });
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement du paiement:", error);
      const errorMessage = extractPaymentErrorMessage(error, "Une erreur est survenue lors de l'enregistrement du paiement");
      setError(errorMessage);
      
      setToastInfo({
        message: errorMessage,
        type: 'error'
      });
    } finally {
      setEnregistrementEnCours(false);
    }
  };
  



  // NOUVEAU : Fonction pour pr?parer un nouveau paiement
  const handleNouveauPaiement = () => {
    // R?initialiser compl?tement le formulaire
    setPaiementEffectue(false);
    setMoisSelectionnes({
      scolarite: [],
      transport: [],
      cantine: []
    });
    setMontantsSaisis({
      scolarite: {},
      transport: {},
      cantine: {}
    });
    setMoisNonScolarises({ //  AJOUTER
      scolarite: [],
      transport: [],
      cantine: []
    });
    setWarningsMontants({ //  AJOUTER
      scolarite: {},
      transport: {},
      cantine: {}
    });
    setPaiementData(prev => ({
      ...prev,
      mode_paiement: '',
      numero_transaction: '',
      commentaire: ''
    }));
    setToastInfo(null);
    setError(null);
  };


  // Fonction pour vérifier si une catégorie est disponible
  const isCategorieDisponible = (categorieId) => {
    if (categorieId === 'scolarite') return true; // Scolarité toujours disponible
  
    const montant = fraisScolaires[categorieId];
    return montant && montant > 0;
  };


  // Obtenir les mois regroup?s par trimestre
  const getMoisParTrimestre = () => {
    const trimestres = {};
    
    moisScolaires.forEach(mois => {
      if (!trimestres[mois.trimestre]) {
        trimestres[mois.trimestre] = [];
      }
      
      trimestres[mois.trimestre].push(mois);
    });
    
    return trimestres;
  };
  

  const getMontantPonctuelSuggere = (categorie) => {
    const baseMensuelle = Number(fraisScolaires[categorie] || 0);
    if (!baseMensuelle) return null;

    const montantJour = Math.max(1, Math.round(baseMensuelle / 20));
    if (categorie === 'transport' && paiementPonctuel.transport.type_paiement === 'demi_journee') {
      return Math.max(1, Math.round(montantJour / 2));
    }
    return montantJour;
  };

  const handlePaiementPonctuelChange = (categorie, field, value) => {
    setPaiementPonctuel(prev => ({
      ...prev,
      [categorie]: {
        ...prev[categorie],
        [field]: value
      }
    }));
  };

  const resetPaiementPonctuel = (categorie) => {
    setPaiementPonctuel(prev => ({
      ...prev,
      [categorie]: createDefaultPaiementPonctuel()[categorie]
    }));
  };

  const handlePaiementPonctuelSubmit = async (categorie) => {
    if (isEleveInFamilleNombreuse) {
      setToastInfo({ message: famillePaymentBlockedMessage, type: 'error' });
      return;
    }

    const data = paiementPonctuel[categorie];
    const montant = Number(String(data.montant || '').replace(/[^0-9]/g, ''));

    if (!paiementData.mode_paiement) {
      setToastInfo({ message: 'Selectionnez un mode de paiement avant d enregistrer le ticket.', type: 'error' });
      return;
    }

    if (!data.date_service) {
      setToastInfo({ message: 'Selectionnez la date du service.', type: 'error' });
      return;
    }

    if (!montant || montant <= 0) {
      setToastInfo({ message: 'Saisissez un montant valide pour le ticket.', type: 'error' });
      return;
    }

    setIsPaiementPonctuelLoading(true);
    setError(null);

    try {
      const response = await api.finance.creerPaiementAnnexePonctuel(eleve.id, {
        annee_scolaire_id: anneeActive.id,
        categorie,
        date_service: data.date_service,
        type_paiement: categorie === 'cantine' ? 'journalier' : data.type_paiement,
        sens_transport: categorie === 'transport' ? data.sens_transport : null,
        montant,
        montant_unitaire: montant,
        mode_paiement: paiementData.mode_paiement,
        observations: data.observations || ''
      });

      if (response.success) {
        setToastInfo({
          message: `${categorie === 'transport' ? 'Ticket transport' : 'Ticket cantine'} enregistre : ${formatMontant(montant)}`,
          type: 'success'
        });
        resetPaiementPonctuel(categorie);
        if (onSave) onSave(response.data);
      } else {
        const message = extractPaymentErrorMessage(response, 'Erreur lors du paiement ponctuel');
        setError(message);
        setToastInfo({ message, type: 'error' });
      }
    } catch (error) {
      const message = extractPaymentErrorMessage(error, 'Erreur lors du paiement ponctuel');
      setError(message);
      setToastInfo({ message, type: 'error' });
    } finally {
      setIsPaiementPonctuelLoading(false);
    }
  };

  const renderPaiementPonctuel = (categorie) => {
    if (!['transport', 'cantine'].includes(categorie)) return null;

    const data = paiementPonctuel[categorie];
    const montantSuggere = getMontantPonctuelSuggere(categorie);
    const label = categorie === 'transport' ? 'Transport ponctuel' : 'Cantine ponctuelle';
    const description = categorie === 'transport'
      ? 'Encaisser un trajet sur une date précise, en journée complète ou en demi-journée.'
      : 'Encaisser un repas ponctuel sur une date précise.';

    return (
      <div className="rounded-md border border-[#246990]/20 bg-[#246990]/5 p-4">
        <div className="mb-3 flex items-start justify-between gap-3">
          <div>
            <div className="text-sm font-semibold text-[#246990]">{label}</div>
            <p className="text-xs text-gray-600">{description}</p>
          </div>

        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
          <div className="space-y-1">
            <Label>Date du service</Label>
            <Input
              type="date"
              value={data.date_service}
              onChange={(e) => handlePaiementPonctuelChange(categorie, 'date_service', e.target.value)}
              disabled={isPaiementPonctuelLoading || isEleveInFamilleNombreuse}
            />
          </div>

          {categorie === 'transport' && (
            <>
              <div className="space-y-1">
                <Label>Type</Label>
                <div className="grid h-9 grid-cols-2 gap-1 rounded-md border bg-white p-1">
                  {[
                    { id: 'journee', label: 'Journée' },
                    { id: 'demi_journee', label: 'Demi-journée' }
                  ].map(option => (
                    <button
                      key={option.id}
                      type="button"
                      onClick={() => handlePaiementPonctuelChange(categorie, 'type_paiement', option.id)}
                      disabled={isPaiementPonctuelLoading || isEleveInFamilleNombreuse}
                      className={`flex h-full items-center justify-center rounded px-2 text-xs font-medium ${data.type_paiement === option.id ? 'bg-[#246990] text-white' : 'text-gray-600 hover:bg-gray-50'}`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="space-y-1">
                <Label>Sens</Label>
                <div className="grid h-9 grid-cols-2 gap-1 rounded-md border bg-white p-1">
                  {[
                    { id: 'aller', label: 'Aller' },
                    { id: 'retour', label: 'Retour' }
                  ].map(option => (
                    <button
                      key={option.id}
                      type="button"
                      onClick={() => handlePaiementPonctuelChange(categorie, 'sens_transport', option.id)}
                      disabled={data.type_paiement === 'journee' || isPaiementPonctuelLoading || isEleveInFamilleNombreuse}
                      className={`flex h-full items-center justify-center rounded px-2 text-xs font-medium ${data.sens_transport === option.id && data.type_paiement !== 'journee' ? 'bg-[#246990] text-white' : 'text-gray-600 hover:bg-gray-50 disabled:opacity-50'}`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}

          <div className="space-y-1">
            <Label>Montant</Label>
            <Input
              type="text"
              inputMode="numeric"
              value={data.montant}
              onChange={(e) => handlePaiementPonctuelChange(categorie, 'montant', e.target.value.replace(/[^0-9]/g, ''))}
              placeholder="Ex: 1000"
              disabled={isPaiementPonctuelLoading || isEleveInFamilleNombreuse}
            />
          </div>
        </div>

        <div className="mt-3 space-y-3">
          <Textarea
            value={data.observations}
            onChange={(e) => handlePaiementPonctuelChange(categorie, 'observations', e.target.value)}
            placeholder="Observation optionnelle"
            rows={2}
            disabled={isPaiementPonctuelLoading || isEleveInFamilleNombreuse}
          />
          <div className="flex justify-end">
            <Button
              type="button"
              onClick={() => handlePaiementPonctuelSubmit(categorie)}
              disabled={isPaiementPonctuelLoading || isEleveInFamilleNombreuse}
              className="h-9 min-w-[168px] justify-center gap-2 bg-[#246990] text-white hover:bg-[#1f5a7a]"
            >
              {isPaiementPonctuelLoading ? 'Enregistrement…' : 'Enregistrer le ticket'}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  // Rendu des lignes de paiement pour une catégorie
  const renderPaiementsCategorie = (categorie) => {
    // Tant que l'historique n'est pas lu, l'etat des mois est inconnu : on ne
    // montre pas un tableau ou tout paraitrait impaye.
    if (chargementHistorique) {
      return (
        <div className="flex items-center justify-center gap-2 rounded-lg border border-[#246990]/20 bg-[#eef7fb] p-8 text-sm text-[#246990]">
          <Loader2 size={16} className="animate-spin" />
          Chargement des paiements de l'élève…
        </div>
      );
    }

    // NOUVEAU : V?rifier si la catégorie est disponible
    if (!isCategorieDisponible(categorie)) {
      return (
        <div className="space-y-4">
          {categorie !== 'scolarite' && renderPaiementPonctuel(categorie)}
          <div className="p-8 text-center bg-gray-50 rounded-md">
            <AlertCircle size={48} className="mx-auto text-gray-400 mb-4" />
            <p className="text-lg font-medium text-gray-700 mb-2">
              Aucun abonnement mensuel de {categorie === 'transport' ? 'transport' : 'cantine'} pour cette classe
            </p>
            <p className="text-sm text-gray-500">
              La classe <strong>{eleve?.classe_nom}</strong> n'a pas de frais mensuel de {categorie === 'transport' ? 'transport' : 'cantine'} configurés. Un paiement ponctuel reste possible au-dessus.
            </p>
          </div>
        </div>
      );
    }
    const trimestres = getMoisParTrimestre();
    
    return (
      <div className="w-full space-y-4">
        {categorie !== 'scolarite' && renderPaiementPonctuel(categorie)}
        {categorie !== 'scolarite' && (
          <div className="flex items-start gap-3 rounded-lg border border-[#246990]/20 bg-[#eef7fb] p-3 text-sm text-gray-700">
            <Info size={16} className="mt-0.5 shrink-0 text-[#246990]" />
            <p className="leading-relaxed">
              <strong className="text-[#246990]">Deux façons de payer, au choix.</strong>{' '}
              {categorie === 'transport' ? 'Un trajet' : 'Un repas'} isolé : remplissez le ticket
              ponctuel ci-dessus et enregistrez-le. L'abonnement du mois : cochez les mois dans le
              tableau ci-dessous, puis validez le paiement en bas de la fenêtre.
            </p>
          </div>
        )}
        <table className="w-full border-collapse">
          <thead className="sticky top-0 z-10 bg-gray-50 shadow-sm">
            <tr className="bg-gray-50">
              <th className="py-2 px-4 text-left font-medium text-gray-600 w-[28%]">Mois</th>
              <th className="py-2 px-4 text-left font-medium text-gray-600 w-1/5">Montant dû</th>
              <th className="py-2 px-4 text-left font-medium text-gray-600 w-1/5">Déjà payé</th>
              <th className="py-2 px-4 text-left font-medium text-gray-600 w-1/5">Reste à payer</th>
              <th className="py-2 px-4 text-left font-medium text-gray-600 w-1/5">à payer</th>
              <th className="py-2 px-4 text-center font-medium text-gray-600 w-1/6">Non scolarisé</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(trimestres).map(trimestre => (
              <React.Fragment key={trimestre}>
                {/* En-tête du trimestre */}
                <tr className="bg-blue-100">
                  <td colSpan="6" className="py-2 px-4 font-semibold text-gray-700">
                    {trimestre === '1' ? 'Premier trimestre' : 
                      trimestre === '2' ? 'Deuxième trimestre' :
                        trimestre === '3' ? 'Troisième trimestre' : `Trimestre ${trimestre}`}
                  </td>
                </tr>
                
                {/* Lignes pour chaque mois */}
                {trimestres[trimestre].map(mois => {
                  // Utiliser l'historique des paiements s'il existe, sinon calculer ? partir des frais
                  const montantDuCategorie = fraisScolaires[categorie] || 0;
                  
                  const historique = historiquesPaiements[categorie][mois.id] || {
                    montant_attendu: montantDuCategorie,
                    montant_paye: 0,
                    montant_restant: montantDuCategorie
                  };
                  
                  const montantDu = historique.montant_attendu || montantDuCategorie;
                  const montantPaye = historique.montant_paye || 0;
                  const montantRestant = historique.montant_restant || montantDu - montantPaye;
                  const estSelectionne = moisSelectionnes[categorie].includes(mois.id);
                  
                
                  
                  //  V?rifier si le mois est déjà payé ou déjà "non scolarisé"
                  const estDejaPaye = moisDejaPayes[categorie].includes(mois.id);
                  const estDejaNonScolarise = moisDejaNonScolarises[categorie].includes(mois.id);

                  return (
                    <tr 
                      key={mois.id} 
                      className={`border-b ${estDejaPaye || estDejaNonScolarise
                          ? 'bg-gray-100 opacity-60' 
                          : mois.ordre % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                        }`}
                    >
                      {/* Colonne Mois */}

                      <td className="py-3 px-4">
                        <div className="flex items-center gap-2">
                          <Checkbox
                            id={`${categorie}-${mois.id}`}
                            checked={estSelectionne}
                            onCheckedChange={() => handleMoisToggle(categorie, mois.id)}
                            disabled={
                              isEleveInFamilleNombreuse ||
                              moisNonScolarises[categorie].includes(mois.id) ||
                              estDejaPaye ||
                              estDejaNonScolarise
                            }
                          />
                          {/* Le nom du mois à gauche, l'état dans une colonne de largeur
                            fixe à droite : les badges s'alignent d'une ligne à l'autre
                            au lieu de suivre la longueur du nom (DESIGN-SYSTEM.md). */}
                          <Label
                            htmlFor={`${categorie}-${mois.id}`}
                            className="flex min-w-0 flex-1 cursor-pointer items-center justify-between gap-2"
                          >
                            <span className={estDejaPaye || estDejaNonScolarise ? 'text-gray-400 line-through' : ''}>
                              {mois.nom}
                            </span>
                          
                            {/*  Badge orange pour retenue sur salaire */}
                            {estDejaPaye && historique.mode_paiement === 'Retenue sur salaire' && (
                              <span className="inline-flex w-[132px] h-6 shrink-0 items-center justify-center gap-1 rounded-full border text-xs font-medium whitespace-nowrap border-orange-200 bg-orange-50 text-orange-700">
                                <User size={12} className="flex-shrink-0" />
                                Via retenue parent
                              </span>
                            )}
                          
                            {/* Badge vert pour paiement normal */}
                            {estDejaPaye && historique.mode_paiement !== 'Retenue sur salaire' && historique.statut !== 'Soldé' && (
                              <span className="inline-flex w-[132px] h-6 shrink-0 items-center justify-center gap-1 rounded-full border text-xs font-medium whitespace-nowrap border-green-200 bg-green-50 text-green-700">Payé</span>
                            )}
                          
                            {/* Badge teal pour Soldé (site source) */}
                            {interSitesOuvert && estDejaPaye && historique.statut === 'Soldé' && (
                              <span className="inline-flex w-[132px] h-6 shrink-0 items-center justify-center gap-1 rounded-full border text-xs font-medium whitespace-nowrap cursor-help border-teal-200 bg-teal-50 text-teal-700"
                                title="Ce mois a été réglé sur l'ancien établissement de l'élève avant son transfert inter-sites"
                              >
                                Soldé (site source)
                              </span>
                            )}
                          
                            {/* Badge gris pour non scolarisé */}
                            {estDejaNonScolarise && (
                              <span className="inline-flex w-[132px] h-6 shrink-0 items-center justify-center gap-1 rounded-full border text-xs font-medium whitespace-nowrap border-gray-200 bg-gray-50 text-gray-600">Non scolarisé</span>
                            )}
                          </Label>
                        </div>
                      </td>



                      {/* Montant dû */}
                      <td className="py-3 px-4 text-gray-700">
                        {formatMontant(montantDu)}
                      </td>
                      
                      {/* Déjà payé */}
                      <td className="py-3 px-4 text-gray-700">
                        {formatMontant(montantPaye)}
                      </td>
                      
                      {/* Reste à payer */}
                      <td className="py-3 px-4 text-gray-700">
                        {formatMontant(montantRestant)}
                      </td>
                      
                      {/* à payer */}
                      <td className="py-3 px-4">
                        <div className="relative">
                          <Input 
                            type="text"
                            inputMode="numeric"
                            value={estSelectionne ? (montantsSaisis[categorie][mois.id] || '') : ''}
                            onChange={(e) => {
                              const value = e.target.value.replace(/[^0-9]/g, '');
                              handleMontantChange(categorie, mois.id, value);
                            }}
                            disabled={
                              isEleveInFamilleNombreuse ||
                              !estSelectionne || 
                              moisNonScolarises[categorie].includes(mois.id) ||
                              estDejaPaye ||
                              estDejaNonScolarise
                            }
                            placeholder="Montant"
                            className={`w-full ${warningsMontants[categorie][mois.id]
                                ? 'border-red-300 focus:border-red-500 focus:ring-red-500' 
                                : ''
                              }`}
                          />
                          
                          {/* Bulle de warning */}
                          {warningsMontants[categorie][mois.id] && (
                            <div className="absolute left-0 top-full mt-1 z-20 w-full animate-in fade-in slide-in-from-top-2 duration-200">
                              <div className="bg-red-50 border border-red-200 rounded-lg p-2 shadow-lg">
                                <div className="flex items-start gap-2">
                                  <AlertCircle size={16} className="text-red-500 flex-shrink-0 mt-0.5" />
                                  <div className="flex-1">
                                    <p className="text-xs text-red-700 font-medium">
                                      Le montant ne peut pas être 0 FCFA
                                    </p>
                                    <p className="text-xs text-red-600 mt-0.5">
                                      Cochez "Non scolarisé" si l'élève n'a pas fréquenté ce mois
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                      
                      {/* Non scolarisé */}
                      <td className="py-3 px-4">
                        <div className="flex items-center justify-center">
                          <Checkbox
                            id={`non-scolarise-${categorie}-${mois.id}`}
                            checked={
                              moisNonScolarises[categorie].includes(mois.id) || 
                              estDejaNonScolarise
                            }
                            onCheckedChange={() => handleNonScolariseToggle(categorie, mois.id)}
                            disabled={
                              isEleveInFamilleNombreuse ||
                              estDejaPaye ||
                              estDejaNonScolarise
                            }
                          />
                          <Label 
                            htmlFor={`non-scolarise-${categorie}-${mois.id}`} 
                            className="ml-2 cursor-pointer text-sm text-gray-600"
                          >
                            <XCircle size={16} className="text-gray-500" />
                          </Label>
                        </div>
                      </td>
                    </tr>
                  );


                })}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );

    
  };
  

  // Fonction pour obtenir la liste des mois sélectionnés (noms)
  const getMoisSelectionnesNoms = () => {
    const tousLesMoisSelectionnes = [];
    const tousLesMoisNonScolarises = [];
  
    // R?cup?rer les mois sélectionnés normalement
    categories.forEach(categorie => {
      const catId = categorie.id;
      moisSelectionnes[catId].forEach(moisId => {
        const mois = moisScolaires.find(m => m.id === moisId);
        if (mois && !tousLesMoisSelectionnes.includes(mois.nom)) {
          tousLesMoisSelectionnes.push(mois.nom);
        }
      });

      //  R?cup?rer les mois non scolarisés
      moisNonScolarises[catId].forEach(moisId => {
        const mois = moisScolaires.find(m => m.id === moisId);
        if (mois && !tousLesMoisNonScolarises.includes(mois.nom)) {
          tousLesMoisNonScolarises.push(mois.nom);
        }
      });
    });
    
    return {
      moisPayes: tousLesMoisSelectionnes.join(', ') || 'Aucun',
      moisNonScolarises: tousLesMoisNonScolarises.join(', ')
    };
  };
  


  // Fonction pour obtenir la liste des catégories sélectionnées (noms)
  const getCategoriesSelectionnees = () => {
    const categoriesAvecPaiement = categories
      .filter(categorie => moisSelectionnes[categorie.id].length > 0)
      .map(categorie => categorie.nom);
  
    const categoriesNonScolarisees = categories
      .filter(categorie => moisNonScolarises[categorie.id].length > 0)
      .map(categorie => categorie.nom);
  
    return {
      avecPaiement: categoriesAvecPaiement.join(', ') || 'Aucune',
      nonScolarisees: categoriesNonScolarisees.join(', ')
    };
  };


  // Gérer le marquage "non scolarisé"
  const handleNonScolariseToggle = (categorie, moisId) => {
    setMoisNonScolarises(prev => {
      const nouveauxMois = [...prev[categorie]];
      const index = nouveauxMois.indexOf(moisId);
    
      if (index === -1) {
        // Marquer comme non scolarisé
        nouveauxMois.push(moisId);
      
        // D?cocher le mois et mettre le montant ? 0
        setMoisSelectionnes(prevSel => ({
          ...prevSel,
          [categorie]: prevSel[categorie].filter(id => id !== moisId)
        }));
      
        setMontantsSaisis(prevMont => ({
          ...prevMont,
          [categorie]: {
            ...prevMont[categorie],
            [moisId]: 0
          }
        }));
      } else {
        // Retirer le marquage non scolarisé
        nouveauxMois.splice(index, 1);
      }
    
      return { ...prev, [categorie]: nouveauxMois };
    });
  };



  //  Fonction pour vérifier s'il y a des warnings actifs
  const hasActiveWarnings = () => {
    if (isEleveInFamilleNombreuse) {
      return true;
    }

    return categories.some(categorie => {
      const catId = categorie.id;
      return moisSelectionnes[catId].some(moisId => {
        return warningsMontants[catId][moisId] === true;
      });
    });
  };


  return (
    <>
      <Dialog
        open={isOpen}
        onOpenChange={(open) => {
          // Empêcher la fermeture si le modal est ouvert et qu'on clique à l'extérieur
          // Ne fermer QUE si on clique explicitement sur les boutons
          if (!open && isOpen) {
            // Ne rien faire - emp?che la fermeture
            return;
          }
          onClose();
        }}
      >
        <DialogContent
          className="w-[95vw] max-w-6xl !max-h-[95vh] overflow-hidden flex flex-col"
          onPointerDownOutside={(e) => {
            // Empêcher la fermeture lors d'un clic à l'extérieur
            e.preventDefault();
          }}
          onEscapeKeyDown={(e) => {
            // Empêcher la fermeture avec la touche Échap
            e.preventDefault();
          }}
        >
            
          <DialogHeader className="p-4 pb-2">
            <DialogTitle className="text-xl font- text-[#246990]">
              {eleve ? `Paiement pour ${eleve.prenom} ${eleve.nom}` : "Nouveau paiement"}
            </DialogTitle>
          </DialogHeader>
          
          <div className="flex-grow overflow-y-auto p-4 pt-0 space-y-4">
            {!habiliteCaisse && <BandeauCaisseReservee />}
            {error && (
              <div ref={blocErreurRef} className="bg-red-50 p-3 rounded-md flex items-start gap-2 text-red-700">
                <AlertCircle size={18} className="shrink-0 mt-0.5" />
                <div>{error}</div>
              </div>
            )}
            
            {/* Informations de l'élève */}
            {eleve && (
              <div className="bg-blue-50 p-3 rounded-md">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center">
                    <User size={18} className="text-[#246990] mr-2" />
                    <div>
                      <div className="text-sm text-[#246990]">élève</div>
                      <div className="font-medium">{eleve.prenom} {eleve.nom}</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <FileText size={18} className="text-[#246990] mr-2" />
                    <div>
                      <div className="text-sm text-[#246990]">Classe</div>
                      <div className="font-medium">{eleve.classe_nom || 'Non assign?'}</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <Users size={18} className="text-[#246990] mr-2" />
                    <div>
                      <div className="text-sm text-[#246990]">Parent</div>
                      <div className="font-medium">{eleve.parent_nom || 'Non renseign?'}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {/* Onglets des catégories */}
            {isEleveInFamilleNombreuse && (
              <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-amber-800">
                <div className="flex items-start gap-2">
                  <AlertCircle size={18} className="mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold">Paiement individuel bloque</p>
                    <p className="mt-1 text-sm">{famillePaymentBlockedMessage}</p>
                    <p className="mt-1 text-xs">
                      Scolarite, transport et cantine restent verrouilles ici pour eviter un ecart comptable.
                    </p>
                  </div>
                </div>
              </div>
            )}

            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList className="w-full bg-gray-100 p-0 rounded-md">
                {categories.map(categorie => {
                  const estDisponible = isCategorieDisponible(categorie.id);
                  
                  return (
                    <TabsTrigger 
                      key={categorie.id} 
                      value={categorie.id}
                      disabled={isEleveInFamilleNombreuse}
                      className={`flex-1 py-2 data-[state=active]:bg-[#246990] data-[state=active]:text-white ${isEleveInFamilleNombreuse ? 'opacity-50 cursor-not-allowed' : !estDisponible ? 'opacity-70 cursor-pointer' : ''
                        }`}
                    >
                      <div className="flex items-center justify-center gap-1.5">
                        {categorie.icon}
                        <span>{categorie.nom}</span>
                        {!estDisponible && (
                          <span className="ml-1 text-xs">(Aucun frais)</span>
                        )}
                      </div>
                    </TabsTrigger>
                  );
                })}
              </TabsList>
              
              {/* Contenu pour chaque onglet */}
              {categories.map(categorie => (
                <TabsContent key={categorie.id} value={categorie.id} className="mt-0 border rounded-md">
                  <div className="max-h-[350px] overflow-y-auto">
                    {renderPaiementsCategorie(categorie.id)}
                  </div>
                </TabsContent>
              ))}
            </Tabs>
            
            {/* Résumé du paiement */}
            <div className="bg-blue-50 p-4 rounded-md">
              <div className="font-semibold text-[#246990] mb-3 flex items-center gap-2">
                <FileText size={18} className="text-[#246990]/70" />
                Résumé du paiement
              </div>
            
              <div className="space-y-3">
                {/* Paiements normaux */}
                {calculerTotalSelectionne() > 0 && (
                  <div className="bg-white p-3 rounded border border-[#246990]/90">

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                      <div>
                        <span className="font-medium text-gray-700">Total à payer: </span>
                        <span className="text-[#319190] font-bold">{formatMontant(calculerTotalSelectionne())}</span>
                      </div>
                    
                      <div>
                        <span className="font-medium text-gray-700">Catégories: </span>
                        <span className="text-[#246990]">{getCategoriesSelectionnees().avecPaiement}</span>
                      </div>
                    
                      <div>
                        <span className="font-medium text-gray-700">Mois: </span>
                        <span className="text-[#246990]">{getMoisSelectionnesNoms().moisPayes}</span>
                      </div>
                    </div>
                  </div>
                )}
              
                {/*  Mois non scolarisés */}
                {getMoisSelectionnesNoms().moisNonScolarises && (
                  <div className="bg-gray-50 p-3 rounded border border-gray-300">
                    <div className="flex items-start gap-2 mb-2">
                      <XCircle size={16} className="text-gray-600 mt-0.5 flex-shrink-0" />
                      <div className="flex-1">
                        <div className="font-medium text-gray-700 mb-1">
                          élève non scolarisé ce(s) mois
                        </div>
                        <div className="text-sm text-gray-600 space-y-1">
                          <div>
                            <span className="font-medium">Catégories: </span>
                            <span>{getCategoriesSelectionnees().nonScolarisees || 'Aucune'}</span>
                          </div>
                          <div>
                            <span className="font-medium">Mois: </span>
                            <span>{getMoisSelectionnesNoms().moisNonScolarises}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-xs text-gray-500 italic flex items-center gap-1 mt-2">
                      <AlertCircle size={12} />
                      Ces mois ne seront pas comptabilis?s comme impayés
                    </div>
                  </div>
                )}

                {/* Message si rien n'est sélectionné */}
                {calculerTotalSelectionne() === 0 && !getMoisSelectionnesNoms().moisNonScolarises && (
                  <div className="text-center py-4 text-gray-500">
                    <AlertCircle size={32} className="mx-auto mb-2 text-gray-400" />
                    <p>Aucun mois sélectionné</p>
                  </div>
                )}
              </div>
            </div>
            
            {/* Options de paiement */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">


              <div className="space-y-2">
                <Label htmlFor="mode_paiement">
                  Mode de paiement <span className="text-red-500">*</span>
                </Label>
  
                <div className="relative">
                  <CreditCard size={16} className="absolute left-3 top-3.5 text-gray-400 pointer-events-none z-10" />
    
                  <input
                    type="text"
                    placeholder="Rechercher un mode de paiement..."
                    value={(() => {
                      if (paiementData.mode_paiement) {
                        return normalizePaymentModeLabel(paiementData.mode_paiement);
                      }
                      return modePaiementSearchTerm;
                    })()}
                    onChange={(e) => {
                      setModePaiementSearchTerm(e.target.value);
                      setIsModePaiementDropdownOpen(true);
                      if (paiementData.mode_paiement) {
                        setPaiementData(prev => ({ ...prev, mode_paiement: '' }));
                      }
                    }}
                    onFocus={() => setIsModePaiementDropdownOpen(true)}
                    disabled={isLoading || isEleveInFamilleNombreuse}
                    className="w-full pl-10 pr-10 py-3 text-base font-medium border-2 border-gray-200 rounded-lg 
                bg-white hover:border-[#246990] focus:border-[#246990] focus:ring-4 focus:ring-[#246990]/10 
                outline-none transition-all
                disabled:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
                  />
    
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
    
                  {/* Dropdown vers le BAS */}
                  {isModePaiementDropdownOpen && !paiementData.mode_paiement && (
                    <div className="absolute z-20 w-full top-full mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto">
                      {(() => {
                        //  Modes de paiement disponibles
                        const modesDisponibles = (() => {
                          // Si montant = 0 ET mois non scolarisés
                          if (calculerTotalSelectionne() === 0 && getMoisSelectionnesNoms().moisNonScolarises) {
                            return [{ id: 'non_scolarise', nom: 'Pas de mode de paiement car non scolarisé' }];
                          }
            
                          // Sinon, modes normaux
                          if (modesPaiement && modesPaiement.length > 0) {
                            return modesPaiement.map(mode => ({ ...mode, nom: normalizePaymentModeLabel(mode?.nom) }));
                          }
            
                          // Modes par défaut
                          return [
                            { id: 1, nom: 'Espèces' },
                            { id: 2, nom: 'Virement' },
                            { id: 3, nom: 'Transfert Mobile' },
                            { id: 4, nom: 'Chèque' }
                          ];
                        })();
          
                        // Filtrer selon la recherche
                        const filteredModes = modesDisponibles.filter(mode =>
                          normalizePaymentModeLabel(mode?.nom).toLowerCase().includes(modePaiementSearchTerm.toLowerCase())
                        );
          
                        if (filteredModes.length === 0) {
                          return (
                            <div className="p-4 text-center text-gray-500 text-sm">
                              Aucun mode de paiement trouvé
                            </div>
                          );
                        }

                        return filteredModes.map((mode) => (
                          <div
                            key={mode.id}
                            onClick={() => {
                              setPaiementData(prev => ({ ...prev, mode_paiement: normalizePaymentModeLabel(mode?.nom) }));
                              setModePaiementSearchTerm('');
                              setIsModePaiementDropdownOpen(false);
                            }}
                            className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b last:border-b-0 transition-colors"
                          >
                            <div className="font-medium text-gray-900 text-base">
                              {normalizePaymentModeLabel(mode?.nom)}
                            </div>
                          </div>
                        ));
                      })()}
                    </div>
                  )}
                </div>
              </div>

              {/* Numéro de transaction */}
              {paiementData.mode_paiement && 
                paiementData.mode_paiement !== 'Pas de mode de paiement car non scolarisé' &&
                ['Virement', 'Transfert Mobile', 'Chèque'].includes(paiementData.mode_paiement) && (
                  <div className="space-y-2">
                    <Label htmlFor="numero_transaction">
                      {paiementData.mode_paiement === 'Chèque' ? 'Numéro de chèque' : 'Numéro de transaction'}
                    </Label>
                    <Input
                      id="numero_transaction"
                      name="numero_transaction"
                      placeholder={
                        paiementData.mode_paiement === 'Chèque' ? 'Ex: 001234567'
                          : paiementData.mode_paiement === 'Virement' ? 'Ex: VIR202412345'
                            : paiementData.mode_paiement === 'Transfert Mobile' ? 'Ex: +242 12 34 56 78'
                              : 'Numéro de référence'
                      }
                      value={paiementData.numero_transaction}
                      onChange={handleInputChange}
                      disabled={isLoading}
                    />
                  </div>
                )}

            </div>
            
            {/* Commentaire */}
            <div className="space-y-2">
              <Label htmlFor="commentaire">Commentaire (optionnel)</Label>
              <Textarea 
                id="commentaire" 
                name="commentaire" 
                placeholder="Informations supplémentaires" 
                value={paiementData.commentaire} 
                onChange={handleInputChange}
                rows={2}
                disabled={isLoading}
              />
            </div>
            
            {/* Option pour notifier le parent */}

            <div className="flex items-center space-x-2">
              <Checkbox 
                id="notifier-parent"
                checked={notifierParent}
                onCheckedChange={setNotifierParent}
              />
              <Label htmlFor="notifier-parent" className="cursor-pointer flex items-center">
                <Bell size={16} className="mr-1.5 text-[#246990]" />
                Notifier le parent par SMS
              </Label>
            </div> 


          </div>
          <DialogFooter className="p-4 pt-2 border-t">
            {!paiementEffectue ? (
              // Boutons AVANT paiement
              <>
                <Button
                  variant="outline"
                  onClick={onClose}
                  disabled={isLoading}
                  className="h-9 min-w-[168px] justify-center gap-2"
                >
                  Fermer
                </Button>
                <Button
                  className={`h-9 min-w-[168px] justify-center gap-2 bg-[#246990] text-white hover:bg-[#1f5a7a] disabled:cursor-not-allowed disabled:opacity-50 ${isEleveInFamilleNombreuse ? 'cursor-not-allowed opacity-50' : ''}`}
                  onClick={isEleveInFamilleNombreuse ? undefined : handleSubmit}
                  aria-disabled={isEleveInFamilleNombreuse}
                  disabled={isLoading || !habiliteCaisse || hasActiveWarnings() || isEleveInFamilleNombreuse} // Desactiver si warnings ou paiement famille
                >
                  {enregistrementEnCours ? 'Enregistrement…' : 'Valider le paiement'}
                </Button>

                {/*  Message d'information si bouton désactivé à cause des warnings */}
                {hasActiveWarnings() && !isLoading && !isEleveInFamilleNombreuse && (
                  <p className="text-sm text-red-600 text-center mt-2 flex items-center justify-center gap-1">
                    <AlertCircle size={16} />
                    Veuillez corriger les montants invalides avant de valider
                  </p>
                )}
                {isEleveInFamilleNombreuse && !isLoading && (
                  <p className="mt-2 flex items-center justify-center gap-1 text-center text-sm text-amber-700">
                    <AlertCircle size={16} />
                    Paiement a effectuer depuis le dossier de la famille nombreuse
                  </p>
                )}
              </>
            ) : (
              // Boutons APR?S paiement
              <>
                <Button
                  variant="outline"
                  onClick={handleNouveauPaiement}
                  className="h-9 min-w-[168px] justify-center gap-2"
                >
                  <Plus size={16} />
                  Nouveau paiement
                </Button>
                <Button
                  onClick={onClose}
                  className="h-9 min-w-[168px] justify-center gap-2 bg-[#246990] text-white hover:bg-[#1f5a7a]"
                >
                  <CheckCircle size={16} />
                  Fermer
                </Button>
              </>
            )}
          </DialogFooter>

        </DialogContent>
      </Dialog>
      
      {/* Toast EN DEHORS du Dialog */}
      {toastInfo && (
        <ToastPortal>
          {shouldUseLongToast(toastInfo.message, toastInfo.type, toastInfo) ? (
            <LongToast
              show
              title={toastInfo.title}
              message={toastInfo.message}
              type={toastInfo.type}
              onClose={() => setToastInfo(null)}
            />
          ) : (
            <Toast
              message={toastInfo.message}
              type={toastInfo.type}
              onClose={() => setToastInfo(null)}
            />
          )}
        </ToastPortal>
      )}
    </>
  );
};



export default AddPaymentModal;
